(() => {
  if (window.productQuantityControlsInitialized) return;
  window.productQuantityControlsInitialized = true;

  const quantitySelector = 'input[name="quantity"]';

  function updateQuantity(input, enforceMinimum = false) {
    const minValue = Number(input.dataset.min);
    let currentValue = Number(input.value);

    if (Number.isNaN(minValue) || input.value === '') return;

    if (enforceMinimum && currentValue < minValue) {
      input.value = String(minValue);
      currentValue = minValue;
    }

    const minusButton = input
      .closest('.quantity')
      ?.querySelector('.quantity__button[name="minus"]');

    if (minusButton) {
      minusButton.disabled = currentValue <= minValue;
    }
  }

  function initializeQuantities(root = document) {
    root.querySelectorAll(quantitySelector).forEach((input) => {
      updateQuantity(input, true);
    });
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches(quantitySelector)) {
      updateQuantity(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(quantitySelector)) {
      updateQuantity(event.target, true);
    }
  });

  document.addEventListener(
    'blur',
    (event) => {
      if (event.target.matches(quantitySelector)) {
        updateQuantity(event.target, true);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.quantity__button');
    const input = button
      ?.closest('.quantity')
      ?.querySelector(quantitySelector);

    if (input) {
      setTimeout(() => updateQuantity(input, true), 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeQuantities();
    });
  } else {
    initializeQuantities();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeQuantities(event.target);
  });
})();